module.exports = __webpack_public_path__ + "img/signup-guide-02-05.df533d16.png";